import { render, staticRenderFns } from "./ThreatsTab.vue?vue&type=template&id=4eacdbdc&scoped=true&"
import script from "./ThreatsTab.vue?vue&type=script&lang=js&"
export * from "./ThreatsTab.vue?vue&type=script&lang=js&"
import style0 from "./ThreatsTab.vue?vue&type=style&index=0&id=4eacdbdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eacdbdc",
  null
  
)

export default component.exports